
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activities/booking-page",
      function () {
        return require("private-next-pages/activities/booking-page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activities/booking-page"])
      });
    }
  